import SeoMetaData from "common/SeoMetaData"
import FaqPage from "components/Faq/FaqPage"
import { useState } from "react"

const Faq = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [refList, setRefList] = useState([])
  const seo = {
    title: "עמוד שאלות ותשובות לגיפטקארד מקדונלדס",
    description: "עמוד שבו אפשר למצוא שאלות ותשובות לגיפטקארד מקדונלדס",
    keywords: "שאלות ותשובות ,גיפטקארד, מקדונלדס",
  }

  return (
    <>
      {/* removed KeyboardNavigation according to the accessibility consultant */}
      {/* <KeyboardNavigation refList={refList} /> */}
      <SeoMetaData data={seo} />
      <FaqPage setRefList={setRefList} />
    </>
  )
}

export default Faq
